<template>
  <b-modal :id="modalId" ref="modal" title="Ajouter une nouvelle grille">
    <b-form @submit.stop.prevent="onSubmit">
      <p>
        <small
          >Cette nouvelle grille doit être assigné aux délibérations d'un ou
          plusieurs groupes en particulier.</small
        >
      </p>
      <b-form-group label="Nom de la grille*" label-for="name-input">
        <b-form-input
          size="sm"
          id="name-input"
          name="name-input"
          v-model="form.name"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Groupe(s) assigné(s)*" label-for="name-input">
        <p>
          <small
            ><i>
              Pour les groupes non sélectionnés, la grille par défaut sera
              utilisée.
            </i></small
          >
        </p>
        <b-form-select
          v-model="form.groups"
          :options="groups.data.data"
          id="select-horizontal"
          text-field="name"
          value-field="id"
          multiple
          :select-size="4"
        >
        </b-form-select>
      </b-form-group>
    </b-form>
    <template v-slot:modal-footer="{ ok, close }">
      <b-btn pill variant="outline-secondary" @click="close()">Annuler</b-btn>

      <b-btn
        pill
        @click="onSubmit(ok)"
        variant="primary"
        :disabled="callStatus == 'fetching'"
      >
        <span>Ajouter</span>
        <b-spinner
          class="ml-2"
          small
          v-if="callStatus == 'fetching'"
        ></b-spinner
      ></b-btn>
    </template>
  </b-modal>
</template>

<script>
/**
 * @file       New grid modal component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { mapState } from "vuex";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "newGridModal",

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      modalId: "newGridModal",
      form: {
        name: "",
        groups: []
      }
    };
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      callStatus: state => state.grid.comment.created.status,
      grid: state => state.grid.reference,
      groups: state => state.groups.teacherGroups,
      profile: state =>
        state.auth.profile.data ? state.auth.profile.data.data.find(u => u) : {}
    })
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Called on submit.
     *
     * @param      {Function}  ok     Submit action
     */
    onSubmit(ok) {
      if (this.form.name && this.form.groups.length) {
        this.$store
          .dispatch("grid/postGridAssign", {
            groups: this.form.groups,
            name: this.form.name
          })
          .then(() => {
            this.resetForm();
            ok();
          });
      }
    },
    /**
     * Resets the form.
     */
    resetForm() {
      this.form = {
        name: null,
        groups: []
      };
    }
  },
  mounted() {
    this.$store.commit("groups/setTeacherGroupsFilters", {
      reset: true,
      fields: {
        teacher: this.profile.id,
        resourcesPerPage: 50
      }
    });
    this.$store.dispatch("groups/getTeacherGroups");
  }
};
</script>

<style lang="scss" scoped></style>
